"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVideoContent = exports.getChannelContent = void 0;
var getChannelContent = function (channelData) { return ({
    title: channelData.title,
    description: channelData.description,
    coverUrl: channelData.customCoverUrl || channelData.coverUrl,
}); };
exports.getChannelContent = getChannelContent;
var getVideoContent = function (videoItem) { return ({
    title: videoItem.title,
    description: videoItem.description,
    coverUrl: videoItem.customCoverUrl || videoItem.coverUrl,
}); };
exports.getVideoContent = getVideoContent;
//# sourceMappingURL=content.js.map